module.exports = __webpack_public_path__ + "media/theme/close-65085cc5.png";